module.exports = __webpack_public_path__ + "img/windscreen-air-white.c8e436d4.svg";